<template>
  <div style="height: 100dvh">
    <!-- <b-overlay :show="showSpinner" rounded="sm"> -->
    <mobHeader />
    <div class="mobile-body-xp">
      <b-overlay style="height: 100%" :show="showSpinner">
        <div class="mobile-white-body h-100">
          <div class="exPan-overflow">
            <div class="mob-blue-cont">
              <div class="mob-head-txt">Job Details</div>
              <div class="mob-small-txt mt-2">Job Name</div>
              <div class="mob-bold-txt mt-1">{{ jdName }}</div>
              <div class="mob-small-txt mt-2">Time Scheduled</div>
              <div class="mob-bold-txt mt-1">
                {{ interviewDetails.formattedStart }}
              </div>
              <div class="mob-small-txt mt-2">Panel</div>
              <div class="mt-1 d-flex flex-wrap">
                <div>
                  <div class="mob-bold-txt mt-1">
                    {{ combinedPanelists[0] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mob-blue-cont mt-3">
              <div class="d-flex justify-content-between">
                <div class="mob-head-txt">Candidate Details</div>
                <div @click="exportResume(candidateInfo)">
                  <img
                    src="../../assets/panelMob/mob-panel-dowload.svg"
                    alt=""
                  />
                </div>
              </div>
              <div class="mob-small-txt mt-2">Candidate Name</div>
              <div class="mob-bold-txt mt-1">{{ candidateInfo.fullName }}</div>
              <div class="mob-small-txt mt-2">Email</div>
              <div class="mob-bold-txt mt-1">{{ candidateInfo.email }}</div>
              <div class="mob-small-txt mt-2">Contact No.</div>
              <div class="mob-bold-txt mt-1">
                {{ candidateInfo.phoneNumber }}
              </div>
              <div class="mob-small-txt mt-2">Education Qualification</div>
              <div class="mob-bold-txt mt-1">
                {{
                  candidateInfo.qualification
                    ? candidateInfo.qualification
                    : "--"
                }}
              </div>
              <div class="mob-small-txt mt-2">Skills</div>
              <div class="mt-1 d-flex flex-wrap">
                <div
                  class="mob-bold-txt"
                  v-for="(skills, index) in candidateInfo.skills"
                  :key="index"
                >
                  {{ skills }}
                  <span v-if="index < candidateInfo.skills.length - 1">,</span>
                </div>
              </div>
            </div>
            <div
              class="p-2 position-relative mt-3 d-flex justify-content-center"
            >
              <div
                class="xp-alert-card d-flex align-items-start p-3"
                v-if="giveFeedback && interviewDetails.feedback === false"
              >
                <div class="mr-3">
                  <img
                    src="../../assets/panelMob/yellowEXPanAlert.svg"
                    alt=""
                  />
                </div>
                <div class="mob-bold-txt-2">
                  You cannot provide feedback to <br />
                  this candidate before the <br />
                  Scheduled time
                </div>
              </div>

              <div
                class="w-100"
                :class="
                  giveFeedback && interviewDetails.feedback === false
                    ? 'card-blur'
                    : ''
                "
              >
                <div class="mob-head-txt">
                  {{
                    !interviewDetails.feedback
                      ? "Give Feedback"
                      : "View Feedback"
                  }}
                </div>
                <div class="position-relative mt-2 pl-1" v-if="showRecOptions">
                  <div class="mob-black-txt">
                    Recommendation<span class="asterik">*</span>
                  </div>
                  <SelectCustom
                    :disableDropdown="interviewDetails.feedback === true"
                    :mandatory="true"
                    :placeholder="'Select'"
                    :values="getFilteredRecOptions"
                    :dropdown="true"
                    @select-value="
                      (recOption = $event),
                        (recommendation =
                          thirdPartyData.recommendationKey[$event])
                    "
                    :vmodel="recOption"
                    :noLabel="true"
                    :showError="$v.recOption.$error"
                    :disabled="interviewDetails.feedback === true"
                  />
                  <div v-if="$v.recOption.$error" class="error-txt-tc">
                    Required
                  </div>
                </div>
                <div v-else class="mt-2 pl-1">
                  <div class="mob-black-txt">
                    Recommendation<span class="asterik">*</span>
                  </div>
                  <div
                    class="moballocateradio d-flex align-items-ce nter mt-2"
                    :class="
                      $v.recommendation.$error &&
                      interviewDetails.feedback === false
                        ? 'recomendation-error'
                        : 'allocateradios'
                    "
                  >
                    <div
                      v-if="interviewDetails.feedback === false"
                      class="d-flex align-items-center"
                    >
                      <b-form-radio
                        v-model="recommendation"
                        name="some-radios"
                        value="S"
                        :disabled="interviewDetails.feedback === true"
                      >
                        Select
                      </b-form-radio>
                      <b-form-radio
                        v-model="recommendation"
                        name="some-radios"
                        value="R"
                        :disabled="interviewDetails.feedback === true"
                        class="ml-3"
                      >
                        Reject
                      </b-form-radio>
                      <b-form-radio
                        v-model="recommendation"
                        name="some-radios"
                        value="H"
                        v-if="!automatic"
                        :disabled="interviewDetails.feedback === true"
                        class="ml-3"
                      >
                        Hold
                      </b-form-radio>
                      <b-form-radio
                        v-model="recommendation"
                        name="some-radios"
                        value="DNA"
                        :disabled="interviewDetails.feedback === true"
                        class="ml-3"
                      >
                        No Show
                      </b-form-radio>
                    </div>
                    <div v-else class="d-flex align-items-center">
                      <b-form-radio
                        v-if="
                          recommendation == 'S' &&
                          interviewDetails.feedback === true
                        "
                        v-model="recommendation"
                        name="some-radios"
                        value="S"
                        :disabled="interviewDetails.feedback === true"
                      >
                        Select
                      </b-form-radio>
                      <b-form-radio
                        v-if="
                          recommendation == 'R' &&
                          interviewDetails.feedback === true
                        "
                        v-model="recommendation"
                        name="some-radios"
                        value="R"
                        :disabled="interviewDetails.feedback === true"
                        class="ml-3"
                      >
                        Reject
                      </b-form-radio>
                      <b-form-radio
                        v-if="
                          recommendation == 'H' &&
                          interviewDetails.feedback === true
                        "
                        v-model="recommendation"
                        name="some-radios"
                        value="H"
                        :disabled="interviewDetails.feedback === true"
                        class="ml-3"
                      >
                        Hold
                      </b-form-radio>
                      <b-form-radio
                        v-if="
                          recommendation == 'DNA' &&
                          interviewDetails.feedback === true
                        "
                        v-model="recommendation"
                        name="some-radios"
                        value="DNA"
                        :disabled="interviewDetails.feedback === true"
                        class="ml-3"
                      >
                        No Show
                      </b-form-radio>
                    </div>
                  </div>
                </div>
                <div class="pl-1">
                  <div class="mob-small-txt-2 mt-2">
                    Remarks<span class="asterik">*</span>
                  </div>

                  <div class="mt-1">
                    <b-form-textarea
                      class="newInt-previewInputField"
                      :class="{
                        error:
                          $v.recruiterRemarks.$error ||
                          !$v.recruiterRemarks.maxLength,
                      }"
                      v-model="recruiterRemarks"
                      rows="3"
                      placeholder="Enter"
                      :disabled="interviewDetails.feedback === true"
                      max-rows="4"
                    >
                    </b-form-textarea>
                    <div
                      v-if="
                        !$v.recruiterRemarks.maxLength &&
                        interviewDetails.feedback === false
                      "
                      class="mobile-error-txt-tc"
                    >
                      Exceeded the max char length of 256
                    </div>
                    <div
                      v-else-if="$v.recruiterRemarks.$error"
                      class="mobile-error-txt-tc"
                    >
                      Required
                    </div>
                  </div>
                </div>
                <div class="pl-1 mt-3">
                  <!-- <div class="pff-add-left-main-headings">
                  Candidate Name<span class="asterik">*</span>
                </div>
                <div class="mob-div-input mt-1">
                  <div class="w-95 text-truncate">
                    {{ candidateInfo.fullName }}
                  </div>
                </div> -->
                  <div class="pff-add-left-main-headings mt-2">
                    Evaluation Date
                  </div>
                  <div class="mob-div-input">
                    <div class="w-95 text-truncate mt-1">
                      {{ getCurrentDate }}
                    </div>
                  </div>
                  <div class="pff-add-left-main-headings mt-2">Panel Name</div>
                  <div class="mob-div-input">
                    <div class="w-95 text-truncate mt-1">{{ panelName }}</div>
                  </div>
                  <div class="pff-add-left-main-headings mt-2">
                    Mode of Interview
                  </div>
                  <div class="mob-div-input">
                    <div class="w-95 text-truncate mt-1">Face to Face</div>
                  </div>
                </div>

                <!-- CLASS BINDING FOR VIEW DIV - 
          givefdbck-grey-containers-mob
          -->
                <template
                  v-if="recommendation != 'DNA' && recommendation != 'NI'"
                >
                  <div
                    :class="{
                      error:
                        ($v.skills.$each[index].mark.$error ||
                          $v.skills.$each[index].comments.$error ||
                          !$v.skills.$each[index].comments.maxLength ||
                          !$v.skills.$each[index].mark.between) &&
                        interviewDetails.feedback === false,
                      'givefdbck-grey-containers-mob':
                        interviewDetails.feedback === true,
                    }"
                    class="mt-3 ml-1 givefdbck-blue-containers-mob"
                    v-for="(input, index) in skills"
                    :key="index"
                  >
                    <div>
                      <div class="w-100 mob-black-txt-2 text-truncate">
                        {{ input.name }}<span class="asterik">*</span>
                      </div>

                      <div
                        v-if="input.markingType == 'rating'"
                        class="d-flex align-items-center"
                      >
                        <div class="mob-grey-txt">Rating</div>
                        <div class="extpanelist-rating-input">
                          <b-form-rating
                            variant="primary"
                            v-model="input.mark"
                            :disabled="interviewDetails.feedback === true"
                            class="newInt-rating p-0 w-25 ml-2"
                          ></b-form-rating>
                        </div>
                      </div>

                      <div v-if="input.markingType == 'score'" class="mt-2">
                        <div class="topDiv d-flex align-items-center">
                          <div class="mob-grey-txt">Score</div>
                          <div class="ml-2 w-15">
                            <b-form-input
                              class="newInt-previewInputField"
                              v-model="input.mark"
                              :disabled="interviewDetails.feedback === true"
                            >
                            </b-form-input>
                          </div>
                          <div class="ml-2 mob-grey-txt">Out of 10</div>
                          <div
                            class="mobile-error-txt-tc ml-2"
                            v-if="
                              !$v.skills.$each[index].mark.between &&
                              interviewDetails.feedback === false
                            "
                          >
                            Should be between 1 to 10
                          </div>
                        </div>
                      </div>

                      <div v-if="input.commentMode == true" class="mt-1">
                        <div class="topDiv">
                          <div>
                            <label class="mob-grey-txt">Comments</label>
                          </div>
                          <div class="mt-1">
                            <b-form-textarea
                              placeholder="Enter"
                              class="newInt-previewInputField"
                              v-model="input.comments"
                              :disabled="interviewDetails.feedback === true"
                              rows="3"
                              max-rows="4"
                            >
                            </b-form-textarea>
                            <div
                              v-if="
                                !$v.skills.$each[index].comments.maxLength &&
                                !interviewDetails.feedback
                              "
                              class="mobile-error-txt-tc"
                            >
                              Exceeded the max char length of 124
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="
                      panelDetails.screenshot == true &&
                      recommendation != 'DNA' &&
                      recommendation != 'NI'
                    "
                    class="mt-3 ml-1"
                    :class="
                      interviewDetails.feedback === true
                        ? ' givefdbck-grey-containers-mob'
                        : 'givefdbck-blue-containers-mob'
                    "
                  >
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        mob-black-txt-2
                      "
                    >
                      <div class="d-flex align-items-center">
                        <img
                          class="mr-2"
                          src="../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                          alt=""
                        />Candidate Screenshot<span class="asterik">*</span>
                      </div>
                      <div
                        class="d-flex align-items-center"
                        v-if="
                          candidateImage != '' &&
                          !showErrorImage &&
                          !isFailed &&
                          fileCheckImage &&
                          interviewDetails.feedback === false
                        "
                      >
                        <div class="ucdSelDocFile position-relative">
                          <input
                            type="file"
                            multiple
                            class="pointer inputimage"
                            accept="image/jpeg, image/png"
                            @change="previewImage"
                          />
                          <img
                            src="../../assets/panelMob/mobileReplace.svg"
                            alt=""
                          />
                        </div>
                        <div class="xp-vertical-line ml-2 mr-2"></div>
                        <div>
                          <img
                            @click="removeImage()"
                            src="../../assets/panelMob/mobileDelete.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        candidateImage == '' ||
                        isFailed ||
                        showErrorImage ||
                        !fileCheckImage
                      "
                      class="
                        xp-white-upload-card
                        d-flex
                        justify-content-between
                        align-items-center
                        mt-3
                      "
                      :class="
                        showErrorImage ||
                        isFailed ||
                        (candidateImage != '' && !fileCheckImage)
                          ? 'error'
                          : ''
                      "
                    >
                      <div>
                        <div class="xp-upload-txt">Upload File</div>
                        <div class="xp-small-txt mt-1">
                          (.png, .jpg. jpeg) max 5 mb
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <!-- <div class="errortxt text-right" v-if="showErrorImage">
                        Upload Failed
                      </div> -->
                        <div
                          class="errortxt text-right"
                          v-if="candidateImage != '' && isFailed"
                        >
                          Invalid Format
                        </div>
                        <div
                          class="errortxt text-right"
                          v-else-if="candidateImage != '' && !fileCheckImage"
                        >
                          File limit <br />
                          exceeded
                        </div>
                        <div class="xp-vertical-line ml-2 mr-2"></div>
                        <div class="ucdSelDocFile position-relative">
                          <input
                            type="file"
                            multiple
                            class="pointer inputimage"
                            accept="image/jpeg, image/png"
                            @change="previewImage"
                          /><img
                            src="../../assets/panelMob/roundUpload.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="extp-cand-ssbox mt-2 text-center"
                      v-else-if="
                        (image != '' || candidateImage != '') &&
                        !isFailed &&
                        fileCheckImage
                      "
                    >
                      <img
                        :src="candidateImage"
                        :alt="screenshotname"
                        style="max-width: 100%; max-height: 100%"
                      />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div
            v-if="interviewDetails.feedback === false"
            class="
              border-top
              d-flex
              justify-content-end
              align-items-center
              bluebtn
              h-8
              pr-3
            "
          >
            <div class="position-relative">
              <b-button
                class="acs-addBtn width-87"
                :class="feedbackLoader ? 'loader-class-send ' : ''"
                :disabled="giveFeedback && interviewDetails.feedback === false"
                @click="!feedbackLoader ? sendFeedback() : ''"
              >
                <span v-if="!feedbackLoader">Send</span></b-button
              >
              <div v-if="feedbackLoader" class="loader-pos-send">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import panelMixins from "../../views/panelLogin/panelMixins.js";
import Loader from "../../components/fixedcomponents/Loader.vue";

import { exportResume } from "../../controllers/panelLogin/asynchronous.js";

import { getFeedbackFormfromUuid } from "../../utils/apiFunctions.js";

import toast from "../../components/mixin/toast";
import {
  required,
  requiredIf,
  between,
  maxLength,
} from "vuelidate/lib/validators";
import mobHeader from "../../components/fixedcomponents/MobHeader.vue";
import SelectCustom from "../../components/InputComponents/SelectCustom";

export default {
  components: {
    mobHeader,
    Loader,
    SelectCustom,
  },
  data() {
    return {
      feedbackLoader: false,
      getSkills: [],
      modeOfInterview: "",
      fileSize: "5",
      showErrorImage: false,

      interviewResponseskills: [],
      showSpinner: false,
      interviewResponse: {},
      fileCheckImage: false,
      panelName: "",
      jdName: "",
      skills: [],
      getCurrentDate: "",
      candidateImage: "",
      isFailed: false,
      checkimage: false,
      image: "",
      screenshotname: "",
      customFeedback: {},
      candidateInfo: {},
      processedBy: "Panel",
      showfeedbackSpinner: false,
      automatic: false,
      recruiterRemarks: "",
      jobType: "",

      panelDetails: {},
      interviewDetails: {},
      roundName: "",

      candidateName: "",
      recommendation: "",
      recOption: "",
      thirdPartyData: {},
    };
  },
  computed: {
    showRecOptions() {
      if (this.thirdPartyData?.feedbackTypeID == "FEEDBACK2") return true;
      return false;
    },
    getFilteredRecOptions() {
      if (this.showRecOptions) {
        return Object.entries(this.thirdPartyData.feedbackLevelOptions).map(
          ([key, label]) => {
            return { key, label };
          }
        );
      }
      return [];
    },
    giveFeedback() {
      try {
        let result;
        const currentDate = new Date();
        const startTime = new Date(this.interviewDetails.startTime);
        const startTimeLocal = new Date(
          startTime.toLocaleString("en-US", { timeZone: "UTC" })
        );

        // Compare dates
        if (startTimeLocal > currentDate) {
          result = true;
        } else {
          result = false;
        }

        return result;
      } catch (error) {
        return false;
      }
    },
  },
  mixins: [toast, panelMixins],

  validations() {
    return {
      recruiterRemarks: {
        required,
        maxLength: maxLength(256),
      },

      recommendation: { required },
      image: { required },
      recOption: {
        required: requiredIf(() => this.showRecOptions),
      },
      skills: {
        $each: {
          comments: {
            required: requiredIf((obj) => obj.commentMode),
            maxLength: maxLength(124),
          },
          mark: {
            required: requiredIf((obj) => obj.markingType != ""),
            between: between(1, 10),
          },
        },
      },
    };
  },

  methods: {
    openGiveFeedbackModal() {
      this.skills = this.getSkills;
      this.$v.$reset();

      this.$bvModal.show("fillfeedback");
    },
    viewFeedbackModal() {
      this.$bvModal.show("viewfilledfbckform");
    },
    closeFillFeedback() {
      this.recommendation = "";
      this.recruiterRemarks = "";

      this.$bvModal.hide("fillfeedback");
      for (let i = 0; i < this.skills && this.skills.length; i++) {
        this.skills[i].comments = "";
        this.skills[i].mark = "";
      }
    },
    async exportResume(data) {
      await exportResume(data, this);
    },
    getPanelResponse() {
      this.fileCheckImage = true;
      if (this.interviewDetails.feedback) {
        this.candidateImage = this.interviewResponse.candidateImage;
        this.screenshotname = this.interviewResponse.candidateImageKey;
        this.recommendation = this.interviewResponse.recommendation;
        this.recruiterRemarks = this.interviewResponse.recruiterRemarks;
        if (this.panelDetails.feedbackText && this.showRecOptions) {
          this.recOption = Object.keys(
            this.thirdPartyData.feedbackLevelOptions
          ).find(
            (key) =>
              this.thirdPartyData.feedbackLevelOptions[key] ===
              this.panelDetails.feedbackText
          );
        }
        const date = new Date(this.interviewResponse.evalDate);

        // Extract day, month, and year components
        const day = date.getDate();
        const month = date.getMonth() + 1; // Adding 1 because months are zero-based
        const year = date.getFullYear();

        // Create a formatted date string in DD-MM-YYYY format
        const formattedDate = `${day}-${month}-${year}`;

        this.getCurrentDate = formattedDate;
        this.skills = this.interviewResponse.customFeedback.skills;

        this.getPanelSkills();
      }
    },
    getPanelSkills() {
      for (const i of this.skills) {
        for (const j of this.interviewResponse.customFeedback.skills) {
          if (i.commentMode) {
            i.comments = j.comments;
          }
          if (i.markingType == "score") {
            i.mark = j.mark;
          }
          if (i.markingType == "rating") {
            this.skills[i].mark = j.mark;
          }
        }
      }
    },
    async getPanelDetails() {
      try {
        this.showSpinner = true;

        let payload = {
          uuid: this.$route.query.uuid,
        };

        // Fetch panel details using the payload
        const response = await getFeedbackFormfromUuid(payload);
        if (response.status == 200) {
          setTimeout(() => {
            this.showSpinner = false;
          }, 200);
        } else if (response.status === 401 || response.status === 404) {
          this.$router.push({ path: "/404" });
        }
        this.automatic =
          response.data.data.interviewDetails.interviewRound.automated;
        this.candidateInfo = response.data.data.candidateInfo;
        this.interviewDetails = response.data.data.interviewDetails;
        this.modeOfInterview = this.interviewDetails.interviewRound.type;
        this.thirdPartyData = response.data.data.configuration;

        // Store fetched panel details in component properties
        this.panelDetails = response.data.data;
        this.interviewResponse = response.data.data.interviewResponse;
        this.roundName = this.interviewDetails.interviewRound.id;

        const roundNumber = parseInt(this.roundName);

        if (this.roundName === "F") {
          this.roundName = "Final Round";
        } else if (!isNaN(roundNumber)) {
          this.roundName = "Round " + roundNumber;
        }

        this.jdName = response.data.data.jobName;
        this.jobType = response.data.data.jobType;
        this.panelName = this.extPanel;

        this.getSkills = response.data.data.skills;
        this.skills = this.getSkills;
        this.recommendation = response.data.data.recommendation;
        if (this.candidateInfo.experience == null) {
          this.candidateInfo.experience = "Not Mentioned";
        }
        this.getPanelResponse();
      } catch (error) {
        console.error("Error in getPanelDetails:", error);
        if (error.response.status === 401 || error.response.status === 404) {
          this.$router.push({ path: "/404" });
        }
      }
    },
  },
};
</script>

<style>
.small-txt-head {
  color: #72738e;
  font-size: 18px;
  font-weight: 500;
}

.exterpan-overflow {
  height: 91%;
  overflow: auto;
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
}

.h-95 {
  height: 95%;
}
.up-dot-main {
  text-align: center;

  padding: 1px;
}
input[type="file"] {
  opacity: 0;
}
.up-dot-bg {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%2372738EFF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='18' stroke-linecap='square'/%3e%3c/svg%3e");

  border-radius: 13px;
}
.panlg-blueTxt {
  color: #257cff;
  font-size: 12px;
  font-weight: 400;
}

.exterpan-footer {
  height: 9%;
  border-radius: 5px;
  background: #fff;
  border-top: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 10px 0px;
}
.plogin-fdbckname-box {
  background: #e8f0fe;
  border: 1px solid #eaeaea;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px 10px 0px 0px;
  padding: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}
.jd-max-size {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #72738e;
}
.panel-skills-text {
  color: #545454;
  font-size: 14px;
  font-weight: 600;
}

.inputimage {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
}

.mob-greybtn {
  border-radius: 3px;
  background: #72738e;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
}
.extpanel-warn {
  position: relative;
  top: 98px;
}

#viewfilledfbckform .modal-body {
  padding: 0px;
}

#fillfeedback .modal-body {
  padding: 0px;
}
.plogon-skillcard-heading {
  font-weight: 500;
  font-size: 16px;
  color: #696969;
}

.loader-pos-send {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -1px;
}

.loader-class-send {
  opacity: 0.5;
  height: 33px;
  width: 87px;
  border-radius: 20px;
}
.mobile-error-txt-tc {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  color: #eb0002;
}
</style>
